import html from "./ProviderSearch.html"
import "./ProviderSearch.css"
import { getRedirectTarget, linkAccount } from '../../../helpers/providerAccounts';

var module = angular.module("ResearchKitApplicationModule");

module.component('providerSearch', {
	template: html,
	bindings: {
		previousLocation: '<'
	},
	controller: 'providerSearchController',
	controllerAs: 'vm'
});

module.controller("providerSearchController", ["$scope", "$http", "ceUrl", "$q",
	function ($scope, $http, ceUrl, $q) {
		var vm = this;
		var canceler = $q.defer();

		var searchProviders = _.debounce(function () {
			vm.results = [];
			vm.loading = true;

			canceler.resolve();  // Cancel previous request
			canceler = $q.defer();  // Create a new cancellation token

			var baseUrl = ceUrl.make("api/cfhrprovideraccounts/providers?redirectUrl=" + getRedirectTarget());
			if (vm.searchString && vm.searchString.length) {
				baseUrl = baseUrl + "&keyword=" + vm.searchString;
			} else {
				baseUrl = baseUrl + "&keyword=";
			}

			$http.get(baseUrl, { timeout: canceler.promise }).then(function (response) {
				vm.results = vm.results = response.data;
			}).finally(function () {
				vm.loading = false;
			});
		}, 700);

		$scope.$watch("vm.searchString", function () {
			vm.results = null;
			vm.loading = true;
			searchProviders();
		});

		vm.selectProvider = function (provider) {
			vm.connecting = true;
			linkAccount(provider.ID, vm.previousLocation, null).catch(onError);
		};

		function onError(data) {
			vm.connecting = false;
			vm.errorDetails = data.statusText;
			vm.showError = true;
		}
	}
]);